'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('config');

var getApi = function getApi() {
  return _config.API_HOST + ':' + _config.API_PORT;
};

exports.default = getApi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/utils/Api/getApi.js
// module id = 1303
// module chunks = 0